module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "c2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "xpage"
  }, [_c('h4', {
    staticClass: "chaptitle"
  }, [_c('a', {
    attrs: {
      "href": "#/html/003_toc#c2_"
    }
  }, [_vm._v("ON ABRAHAM LINCOLN")])]), _vm._v(" "), _c('p', {
    staticClass: "textfirst"
  }, [_vm._v("Lincoln was not a perfect man, nor a perfect president. By modern standards, his condemnation of slavery might be considered tentative.")]), _vm._v(" "), _c('p', {
    staticClass: "right2"
  }, [_c('em', [_vm._v("Chicago Tribune")]), _vm._v(", June 26, 2005")])]), _vm._v(" "), _c('div', {
    staticClass: "xpage"
  }, [_c('p', {
    staticClass: "textfirst2"
  }, [_vm._v("I’m fascinated by Lyndon Johnson; there’s a piece of him in me. That kind of hunger—desperate to win, please, succeed, dominate—I don’t know\n    any politician who doesn’t have some of that reptilian side to him. But that’s not the dominant part of me. On the other hand, I don’t know that it was the dominant part of\n    Lincoln. The guy was pretty reflective.")]), _vm._v(" "), _c('p', {
    staticClass: "right2"
  }, [_c('em', [_vm._v("Men’s Vogue")]), _vm._v(", Fall 2006")])]), _vm._v(" "), _c('div', {
    staticClass: "xpage"
  }, [_c('p', {
    staticClass: "textfirst2"
  }, [_vm._v("I cannot swallow whole the view of Lincoln as the Great Emancipator.")]), _vm._v(" "), _c('p', {
    staticClass: "right2"
  }, [_c('em', [_vm._v("Time Magazine")]), _vm._v(", June 26, 2005")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e2502ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/008_chap2.vue
// module id = 78
// module chunks = 0